/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_IntroInputs */

const es_privacy_policy_rights_intro = /** @type {(inputs: Privacy_Policy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependiendo de su jurisdiccion, usted puede tener los siguientes derechos:`)
};

const en_privacy_policy_rights_intro = /** @type {(inputs: Privacy_Policy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depending on your jurisdiction, you may have the following rights:`)
};

/**
* | output |
* | --- |
* | "Depending on your jurisdiction, you may have the following rights:" |
*
* @param {Privacy_Policy_Rights_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_intro = /** @type {((inputs?: Privacy_Policy_Rights_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_intro(inputs)
	return en_privacy_policy_rights_intro(inputs)
});
export { privacy_policy_rights_intro as "privacy_policy.rights.intro" }